import Service from "../Service";
 
const resource = "TasPaymentTransportersCollect/";

export default {
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    list(parameters, requestID) {
        return Service.post(resource + "list", parameters, {
            params: { requestID: requestID },
        });
    },
    save(parameters, requestID) {
        return Service.post(resource + "save", parameters, {
            params: { requestID: requestID },
        });
    },
    history(parameters, requestID) {
        return Service.post(resource + "history", parameters, {
            params: { requestID: requestID },
        });
    },
};